"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Data structure for files:
                                                                                                                                                                                                                                                                   *  path: absolute path of the file
                                                                                                                                                                                                                                                                   *  name: "package.json" or "Dockerfile" or w/e
                                                                                                                                                                                                                                                                   *  content: content of the file
                                                                                                                                                                                                                                                                   *  data: if this is a file we know how to read (e.g. JSON, YAML), the file's data
                                                                                                                                                                                                                                                                   */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _fileConstants.FILE_LOADED) {
    var originalContent = void 0;
    if (state[action.path]) {
      originalContent = state[action.path].originalContent;
    } else {
      originalContent = action.content;
    }
    return _extends({}, state, _defineProperty({}, action.path, {
      path: action.path,
      content: action.content,
      name: action.name,
      data: action.data,
      hash: action.hash,
      originalContent: originalContent
    }));
  }

  if (action.type === _fileConstants.FILE_DELETED) {
    return _extends({}, state, _defineProperty({}, action.path, undefined));
  }

  return state;
};

var _fileConstants = require("./fileConstants");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {};
//# sourceMappingURL=fileReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/file/fileReducer.js
// module id = 247
// module chunks = 0